import { h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'

export const ParcoursNouveautePlus = ({ eventId, title, cacheKey, items, viewAllCTA }) => {
   useLayoutEffect(() => {
      setAllToMaxHeight('.btn-custom-height')
   }, [])

   return (
      <div class="container-fluid">
         <div
            class="row bande_offre-marchand-prospect"
            data-testid={eventId === 'parcoursMarchandNouveauteMobileProspect' ? 'bande-parcours-nouveautes-prospect' : 'bande-parcours-nouveautes-internet-prospect'}
            data-cache-key={cacheKey}
         >
            <div class="col-12">
               <h2 class="mb-2 mb-xl-3">{title}</h2>
            </div>

            <div class="col-12">
               <ul class="row mb-0 list-unstyled">
                  {items.map((item, index) => {
                     return (
                        <li class="col-12 col-sm-4 mb-2 mb-xl-3">
                           <div
                              class="reco-parcours-prospect ob1-card d-flex flex-column h-100 lien-composite"
                              data-pdb-zid={item.analytics.pdbZid}
                              data-pdb-sc={item.analytics.pdbSc}
                              data-pdb-idc={item.analytics.pdbIdc}
                              data-pdb-vi={item.analytics.pdbVi}
                              data-oevent-category={item.analytics.category}
                              data-oevent-action={item.analytics.action}
                              data-oevent-label={item.analytics.label}
                              data-oevent-other={item.analytics.other}
                           >
                              {item.badge && item.badge !== '' ? <div class="ob1-tag ob1-tag-primary">{item.badge}</div> : ''}

                              <div class="img text-center mb-2">
                                 <picture>
                                    <source srcset={`${item.image}?saveas=webp&format=270x180`} media="(max-width: 959px)" />
                                    <source srcset={`${item.image}?saveas=webp&format=335x224`} media="(max-width: 1199px)" />
                                    <img loading="lazy" src={`${item.image}?saveas=webp&format=405x270`} alt="" class=" mw-100" />
                                 </picture>
                              </div>

                              <div class="content h-100 d-flex flex-column">
                                 <h3 class="title pb-0 mb-1">{item.title}</h3>

                                 <p class="description pt-0">{item.description}</p>

                                 <a
                                    href={item.CTA.URL}
                                    aria-label={`${item.CTA.label} : ${item.CTA.ariaLabel}`}
                                    class="btn btn-secondary mt-auto align-self-center btn-custom-height d-flex"
                                    target={item.CTA.target}
                                 >
                                    <span>{item.CTA.label}</span>
                                 </a>
                              </div>
                           </div>
                        </li>
                     )
                  })}

                  <li class="col-12 col-sm-4 mb-2 mb-xl-3">
                     <div class="reco-parcours-prospect ob1-card has-plus d-flex h-100 lien-composite justify-content-center align-items-center">
                        <div class="content">
                           <div class="plus">+</div>
                           <a
                              data-pdb-zid={viewAllCTA.analytics.pdbZid}
                              data-pdb-sc={viewAllCTA.analytics.pdbSc}
                              data-pdb-idc={viewAllCTA.analytics.pdbIdc}
                              data-pdb-vi={viewAllCTA.analytics.pdbVi}
                              data-oevent-category={viewAllCTA.analytics.category}
                              data-oevent-action={viewAllCTA.analytics.action}
                              data-oevent-label={viewAllCTA.analytics.label}
                              data-oevent-other={viewAllCTA.analytics.other}
                              href={viewAllCTA.URL}
                              class="o-link-arrow mt-1"
                           >
                              {viewAllCTA.label}
                           </a>
                        </div>
                     </div>
                  </li>
               </ul>
            </div>
         </div>
      </div>
   )
}
